import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'COMPANY_LINKS.ADD_COMPANY_LINK_MENU';

type AddCompanyLinkMenuPropsType = {
  onAddCompanyLinkClick: () => void;
  onAddFreelancerClick: () => void;
};

export const AddCompanyLinkMenu: React.FC<AddCompanyLinkMenuPropsType> = ({
  onAddCompanyLinkClick,
  onAddFreelancerClick,
}) => {
  const { t } = useTranslation('personDetailsGeneral');

  return (
    <Menu position="right-start">
      <Menu.Target>
        <ActionIcon
          color="blue"
          variant="outline"
          data-testid="add-company-link-menu-button"
        >
          <FontAwesomeIcon icon={faPlus} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={onAddCompanyLinkClick}
          data-testid="add-company-link-button"
        >
          {t(`${TRANS_PATH}.ADD_COMPANY_LINK_BUTTON`)}
        </Menu.Item>
        <Menu.Item
          onClick={onAddFreelancerClick}
          data-testid="add-freelancer-button"
        >
          {t(`${TRANS_PATH}.ADD_FREELANCER_BUTTON`)}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
